import * as React from 'react';
import IAsset from '../models/asset';
import AssetCard from './asset-card';
import './panels.css';
const classNames = require('classnames');

interface State {

}

interface Props {
    className ?: string;
    playable ?: boolean;
    filter ?: string | null;
    assets ?: Array<IAsset>;
    data ?: any;
    onClick ?: (asset: {}, index: number) => void;
    iconClick ?: (event: any, asset: {}, index: number) => void;
    currentIndex ?: number;
}

export default class AssetsPanel extends React.Component<Props, State> {
    public static defaultProps: Partial<Props> = {
        playable: true
    };

    componentWillMount() {
        this.setState({
            assets: this.props.assets,
            data: this.props.data
        });

    }

    render() {
        let _filter = this.props.filter ? this.props.filter.toLowerCase() : null;
        return (
            <div
                className={classNames( (this.state && this.props.assets) ? ('panel panel-left asset-panel scrollable') : ('system-config-left-panel'), this.props.className)}
            >
                {this.props.children}
                {(this.state && this.props.assets) ? this.props.assets.map((asset, i) => {
                    return (_filter == null || (asset.name != null && asset.name.toLowerCase().indexOf(_filter) !== -1))
                        ? <AssetCard
                            key={asset.id !== 0 ? asset.id : asset.name}
                            asset={asset}
                            playable={this.props.playable}
                            className={`{(i % 2) ? 'even' : 'odd'}asset-card card${(this.props.currentIndex === i) ? ' selected' : ''}`}
                            // className={(i % 2) ? 'even' : 'odd'}
                            onClick={() => this.props.onClick ? this.props.onClick(asset, i) : false}
                            iconClick={(e: any) => this.props.iconClick ? this.props.iconClick(e, asset, i) : false}
                        />
                        : null;
                }) : (this.state && this.props.data) ? this.props.data.map((data: any, i: any) => {
                        return (
                            <div
                                key={i}
                                className=" card asset-card card-content system-config-left-panel"
                                onClick={() => this.props.onClick ? this.props.onClick(data, i) : false}
                            >
                                {data}
                            </div>
                        );
                    }) : null}
            </div>
        );
    }

}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/panels/assets.tsx